import React from 'react'
import { Link } from 'gatsby'
import Card from '../ui/Card'
import Centered from 'shared/ui/Centered'
import Heading from 'shared/ui/Heading'
import { IconList, IconListItem, Icon } from 'shared/ui/IconList'
import TeamBio from '../ui/TeamBio'

export default function TeamMemberPage({ pageContext }) {
  const { teamMember, posts } = pageContext
  return (
    <div>
      <Centered maxWidth="750px">
        <div className="spacing">
          <TeamBio id={teamMember.id} />

          {Array.isArray(posts) && posts.length > 0 && (
            <Card>
              <div className="spacing-small">
                <Heading as="h2" size={4}>
                  My Blog Posts
                </Heading>
                <hr />

                <IconList spacing="small" iconName="arrow-right" iconColor="green">
                  {posts.map((post) => {
                    const { title, slug } = post
                    return (
                      <IconListItem>
                        <Link className="icon-text" to={`/blog/${slug}/`}>
                          <Icon />
                          <span className="text-small">{title}</span>
                        </Link>
                      </IconListItem>
                    )
                  })}
                </IconList>
              </div>
            </Card>
          )}
        </div>
      </Centered>
    </div>
  )
}
